import { PostUserToUserIdCommissionResponse } from "./postResponse"
import { UserToUserIdCommissionPostInputModel } from "./PostInputModel"
import { httpPost } from "../../../../../libs/http/httpPost"

const endpointUrl = "/v1/user/{to_user_id}/commission"

export const postUserToUserIdCommission = async (
  model: UserToUserIdCommissionPostInputModel,
): Promise<PostUserToUserIdCommissionResponse> => {
  return httpPost<PostUserToUserIdCommissionResponse>(endpointUrl, model)
}
